import TrustpilotBand from "@/components/marketing/TrustpilotBand";
import { SectionContainer } from "./HomePrimitives";
import { TRUSTPILOT_BAND } from "@/components/landing/trustpilot";

export default function TrustpilotSection() {
  return (
    <SectionContainer padding="bottom">
      <TrustpilotBand content={TRUSTPILOT_BAND} heartClass="home-hearts" />
    </SectionContainer>
  );
}
